function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { MenuItem, Select, Slider, Stack, styled } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AirbnbSlider = styled(Slider)(function (_ref) {
  var theme = _ref.theme,
    config = _ref.config;
  return {
    color: "#FFB300",
    height: 4,
    padding: "13px 0",
    "& .MuiSlider-thumb": {
      height: 18,
      width: 18,
      backgroundColor: config === null || config === void 0 ? void 0 : config.primaryColor,
      border: "1px solid ".concat(config === null || config === void 0 ? void 0 : config.primaryColor),
      "&:hover": {
        boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)"
      },
      "& .airbnb-bar": {
        height: 9,
        width: 1,
        backgroundColor: config === null || config === void 0 ? void 0 : config.primaryColor,
        marginLeft: 1,
        marginRight: 1
      }
    },
    "& .MuiSlider-track": {
      height: 3,
      color: config === null || config === void 0 ? void 0 : config.primaryColor
    },
    "& .MuiSlider-rail": {
      color: theme.palette.mode === "dark" ? "#bfbfbf" : "#d8d8d8",
      opacity: theme.palette.mode === "dark" ? undefined : 1,
      height: 3
    }
  };
});
export default function PriceRange(_ref2) {
  var range = _ref2.range,
    priceUpdate = _ref2.priceUpdate,
    config = _ref2.config,
    winnreNoAuth = _ref2.winnreNoAuth;
  var _useState = useState(range),
    _useState2 = _slicedToArray(_useState, 2),
    value1 = _useState2[0],
    setValue1 = _useState2[1];
  var minDistance = 5; // slider unit = 10 Lakhs; min distance = 50 Lakhs

  // Slider bounds in units of 10 Lakhs
  var DEFAULT_MIN_UNITS = 0; // 0 (special: menu will show 5 Lac label for 0)
  var DEFAULT_MAX_UNITS = 100; // 100 => 10 Cr
  var _useState3 = useState(DEFAULT_MIN_UNITS),
    _useState4 = _slicedToArray(_useState3, 2),
    minUnits = _useState4[0],
    setMinUnits = _useState4[1];
  var _useState5 = useState(DEFAULT_MAX_UNITS),
    _useState6 = _slicedToArray(_useState5, 2),
    maxUnits = _useState6[0],
    setMaxUnits = _useState6[1];

  // Fetch price range (in Lakhs) and convert to slider units (10 Lakhs)
  useEffect(function () {
    var isMounted = true;
    if (!(winnreNoAuth !== null && winnreNoAuth !== void 0 && winnreNoAuth.get)) return;
    winnreNoAuth.get("/winnre/user/project/price-range").then(function (res) {
      var _res$minPrice, _res$maxPrice;
      console.log("Fetched price range:", res);
      // API returns { minPrice: number, maxPrice: number } in Lakhs
      var minLakhs = Number((_res$minPrice = res === null || res === void 0 ? void 0 : res.minPrice) !== null && _res$minPrice !== void 0 ? _res$minPrice : 0);
      var maxLakhs = Number((_res$maxPrice = res === null || res === void 0 ? void 0 : res.maxPrice) !== null && _res$maxPrice !== void 0 ? _res$maxPrice : 0);

      // If either is 0, fall back to current defaults
      var nextMin = minLakhs > 0 ? Math.max(DEFAULT_MIN_UNITS, Math.ceil(minLakhs / 10)) : DEFAULT_MIN_UNITS;
      var nextMax = maxLakhs > 0 ? Math.min(DEFAULT_MAX_UNITS, Math.floor(maxLakhs / 10)) : DEFAULT_MAX_UNITS;
      if (!isMounted) return;
      setMinUnits(nextMin);
      setMaxUnits(nextMax);

      // Clamp current value within new bounds
      setValue1(function (prev) {
        return [Math.max(nextMin, Math.min(prev[0], nextMax - minDistance)), Math.max(nextMin + minDistance, Math.min(prev[1], nextMax))];
      });
    })["catch"](function () {
      // keep defaults on error
      if (!isMounted) return;
      setMinUnits(DEFAULT_MIN_UNITS);
      setMaxUnits(DEFAULT_MAX_UNITS);
    });
    return function () {
      isMounted = false;
    };
  }, [winnreNoAuth]);

  // Label generator: unit -> string. unit is 10 Lakhs per step
  var unitToLabel = function unitToLabel(u) {
    if (u === 0) return "5 Lac"; // keep legacy default label for 0
    var lakhs = u * 10;
    var cr = Math.floor(lakhs / 100);
    var lacRem = lakhs % 100;
    if (cr > 0) {
      if (lacRem === 0) return "".concat(cr, " Cr");
      return "".concat(cr, " Cr ").concat(lacRem, " Lac");
    }
    return "".concat(lakhs, " Lac");
  };

  // Menu options derived from bounds
  var minOptions = useMemo(function () {
    var upperForMin = Math.max(minUnits, maxUnits - minDistance);
    var arr = [];
    for (var u = minUnits; u <= upperForMin; u++) arr.push(u);
    return arr;
  }, [minUnits, maxUnits]);
  var maxOptions = useMemo(function () {
    var lowerForMax = Math.min(maxUnits, minUnits + minDistance);
    var arr = [];
    for (var u = lowerForMax; u <= maxUnits; u++) arr.push(u);
    return arr;
  }, [minUnits, maxUnits]);
  var handleChange1 = function handleChange1(event, newValue, activeThumb) {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValue1([Math.min(newValue[0], value1[1] - minDistance), value1[1]]);
    } else {
      setValue1([value1[0], Math.max(newValue[1], value1[0] + minDistance)]);
    }
  };
  var valuetext = function valuetext(value) {
    // value is units of 10 Lakhs
    return unitToLabel(value);
  };
  useEffect(function () {
    priceUpdate(value1);
  }, [value1]);
  return /*#__PURE__*/_jsxs("div", {
    className: "mx-2",
    children: [/*#__PURE__*/_jsx(AirbnbSlider, {
      config: config,
      getAriaLabel: function getAriaLabel() {
        return "Price Range";
      },
      min: minUnits,
      max: maxUnits,
      value: value1,
      onChange: handleChange1,
      valueLabelDisplay: "off",
      getAriaValueText: valuetext,
      disableSwap: true
    }), /*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      spacing: 2,
      maxHeight: 40,
      children: [/*#__PURE__*/_jsx(Select, {
        fullWidth: true,
        labelId: "min-select",
        id: "min-select",
        value: value1[0],
        sx: {
          color: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000",
          borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000",
          borderStyle: "solid",
          borderWidth: "1px",
          "&:hover": {
            borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000"
          },
          "&.Mui-focused": {
            borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#9b9b9b"
          }
        },
        displayEmpty: true,
        inputProps: {
          readOnly: false
        },
        onChange: function onChange(val) {
          var newValue = [val.target.value, value1[1]];
          setValue1(newValue);
        },
        children: minOptions.map(function (u) {
          return /*#__PURE__*/_jsx(MenuItem, {
            value: u,
            children: unitToLabel(u)
          }, "min-".concat(u));
        })
      }), /*#__PURE__*/_jsx(Select, {
        fullWidth: true,
        labelId: "max-select",
        displayEmpty: true,
        inputProps: {
          readOnly: false
        },
        id: "max-select",
        value: value1[1],
        sx: {
          color: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000",
          borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000",
          borderStyle: "solid",
          borderWidth: "1px",
          "&:hover": {
            borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000"
          },
          "&.Mui-focused": {
            borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#9b9b9b"
          }
        },
        onChange: function onChange(val) {
          var newValue = [value1[0], val.target.value];
          setValue1(newValue);
        },
        children: maxOptions.map(function (u) {
          return /*#__PURE__*/_jsx(MenuItem, {
            value: u,
            children: unitToLabel(u)
          }, "max-".concat(u));
        })
      })]
    })]
  });
}